import { render, staticRenderFns } from "./LinkedGls.vue?vue&type=template&id=57f61018"
import script from "./LinkedGls.vue?vue&type=script&lang=js"
export * from "./LinkedGls.vue?vue&type=script&lang=js"
import style0 from "./LinkedGls.vue?vue&type=style&index=0&id=57f61018&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports